import { render, staticRenderFns } from "./addressPopup.vue?vue&type=template&id=37365e05&scoped=true&"
import script from "./addressPopup.vue?vue&type=script&lang=js&"
export * from "./addressPopup.vue?vue&type=script&lang=js&"
import style0 from "./addressPopup.vue?vue&type=style&index=0&id=37365e05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37365e05",
  null
  
)

export default component.exports